<template>
  <div class="general-wrapper">
    <div class="header">
      <h2 class="qrw-heading-xl">
        Статистика
        <span class="c-grey">
          Канали трафіку
        </span>
      </h2>
      <div class="group"></div>
    </div>
    <div class="px-50">
      <GeneralInfo />
      <SmallHistogram />
    </div>
  </div>
</template>
<script>
import SmallHistogram from "@/components/stats/SmallHistogram.vue";
import GeneralInfo from "@/components/stats/GeneralInfo.vue";

export default {
  components: {
    SmallHistogram,

    GeneralInfo,
  },
};
</script>
<style scoped></style>
